import { css } from '@emotion/react';


export default $ => css`
  .uweentity-form-container {
    position: relative;
  }

  .stamp-across {
    color: ${$.primaryMain};
    border-top: 1px solid ${$.primaryMain};
    border-bottom: 1px solid ${$.primaryMain};
    text-align: center;
  }

  @media (min-width: 576px) {
    .stamp-across {
      left: 50%;
      top: 50%;
      width: 7em;
      line-height: 1.5em;
      position: fixed;
      z-index: 999;
      font-size: 72pt;
      text-shadow: 9px 9px 20px #000000;
      transform: translate(-50%, -50%);
    }
  }

  @media (max-width: 575.98px) {
    .stamp-across {
      font-size: 25pt;
    }
  }
`;
